/* FlyHigh Detailing — interactividad propia (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Marca automáticamente para animar títulos, textos e imágenes ---------- */
  var AUTO_REVEAL = [
    '.fh-section .fh-h1', '.fh-section .fh-h2', '.fh-section .fh-head .fh-body',
    '.fh-card', '.fh-gallery', '.fh-buy > *', '.fh-stat', '.fh-review',
    '.main-page-title', '.page-width > .rte > p', '.page-width > .rte > h2', '.page-width > .rte > h3', '.page-width > .rte > ul',
    '.collection-hero__title', '.product-grid > li',
    '.jdgm-rev-widg'
  ].join(',');
  function autoTag(root) {
    if (reduceMotion) return;
    (root || document).querySelectorAll(AUTO_REVEAL).forEach(function (el, i) {
      if (el.classList.contains('fh-reveal') || el.closest('.fh-reveal') || el.closest('.fh-lang-gate') || el.closest('.fh-hero__copy') || el.closest('.tax-note')) return;
      if (getComputedStyle(el).display === 'inline') return;
      el.classList.add('fh-reveal');
      if (!el.style.getPropertyValue('--fh-delay')) {
        var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--fh-delay', Math.min(sibs, 5) * 80 + 'ms');
      }
    });
  }

  /* ---------- Letras huecas gigantes: se deslizan al hacer scroll ---------- */
  function initOutlineDrift() {
    if (reduceMotion) return;
    var items = document.querySelectorAll('.fh-outline[data-fh-drift]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el, i) {
        var amt = parseFloat(el.getAttribute('data-fh-drift')) || 0;
        var span = el.firstElementChild;
        if (!amt || !span) return;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (vh - r.top) / (vh + r.height) - 0.5; /* -0.5 → 0.5 */
        var dir = i % 2 ? -1 : 1;
        span.style.transform = 'translate3d(' + (dir * p * amt) + 'vw,0,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Vídeo de fondo: asegurar reproducción en móviles ---------- */
  function initHeroVideo() {
    document.querySelectorAll('.fh-hero__video video').forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.loop = true; v.controls = false;
      if (reduceMotion) { v.removeAttribute('autoplay'); v.pause(); return; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  /* ---------- Apariciones al hacer scroll + cifras animadas ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.fh-reveal:not(.fh-visible), [data-fh-count]:not([data-fh-done])');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('fh-visible'); if (el.hasAttribute('data-fh-count')) finishCount(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('fh-visible');
        if (el.hasAttribute('data-fh-count')) countUp(el);
        io.unobserve(el);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 8% 0px' });
    items.forEach(function (el) { io.observe(el); });
    /* Red de seguridad: lo que ya está en pantalla al cargar aparece siempre */
    setTimeout(function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0 && !el.classList.contains('fh-visible')) {
          el.classList.add('fh-visible');
          if (el.hasAttribute('data-fh-count')) countUp(el);
          io.unobserve(el);
        }
      });
    }, 400);
  }

  function finishCount(el) {
    el.textContent = el.getAttribute('data-fh-prefix') + formatNum(parseFloat(el.getAttribute('data-fh-count')), el) + el.getAttribute('data-fh-suffix');
    el.setAttribute('data-fh-done', '');
  }
  function formatNum(n, el) {
    var dec = parseInt(el.getAttribute('data-fh-decimals') || '0', 10);
    var lang = document.documentElement.lang || 'es';
    return n.toLocaleString(lang, { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-fh-count')) || 0;
    var duration = parseInt(el.getAttribute('data-fh-duration') || '1800', 10);
    var prefix = el.getAttribute('data-fh-prefix') || '';
    var suffix = el.getAttribute('data-fh-suffix') || '';
    var start = null;
    el.setAttribute('data-fh-done', '');
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = prefix + formatNum(target * eased, el) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Parallax suave de las burbujas del hero ---------- */
  function initHeroParallax() {
    if (reduceMotion) return;
    var heroes = document.querySelectorAll('[data-fh-parallax]');
    if (!heroes.length) return;
    heroes.forEach(function (hero) {
      var layer = hero.querySelector('.fh-hero__blobs');
      var intensity = parseFloat(hero.getAttribute('data-fh-parallax')) || 0;
      if (!layer || !intensity) return;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var rect = hero.getBoundingClientRect();
          if (rect.bottom > 0) layer.style.transform = 'translate3d(0,' + (-rect.top * intensity / 100) + 'px,0)';
          ticking = false;
        });
      }, { passive: true });
    });
  }

  /* ---------- Añadir al carrito sin recargar (actualiza el contador) ---------- */
  function bumpBubble() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    bubble.classList.remove('fh-bump');
    void bubble.offsetWidth;
    bubble.classList.add('fh-bump');
  }

  function addToCart(variantId, quantity) {
    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-icon-bubble'];
    if (drawer) sections.unshift('cart-drawer');
    return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status) throw new Error(data.description || data.message || 'Error');
      var item = data.items && data.items[0] ? data.items[0] : {};
      if (drawer && typeof drawer.renderContents === 'function') {
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        drawer.renderContents({ id: item.id, sections: data.sections });
      } else if (data.sections && data.sections['cart-icon-bubble']) {
        var html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        var src = html.querySelector('.shopify-section');
        var dest = document.getElementById('cart-icon-bubble');
        if (src && dest) dest.innerHTML = src.innerHTML;
      }
      setTimeout(bumpBubble, 50);
      return data;
    });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fh-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      var label = btn.querySelector('[data-fh-label]');
      var original = label ? label.textContent : '';
      btn.classList.add('is-loading');
      addToCart(parseInt(btn.getAttribute('data-fh-add'), 10), 1).then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (label) label.textContent = btn.getAttribute('data-fh-added') || original;
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 2200);
      }).catch(function (err) {
        btn.classList.remove('is-loading');
        if (label) label.textContent = err.message;
        setTimeout(function () { if (label) label.textContent = original; }, 3000);
      });
    });
  }

  /* ---------- Página de producto: galería, variantes, cantidad, compra ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-fh-pdp]').forEach(function (pdp) {
      if (pdp.hasAttribute('data-fh-ready')) return;
      pdp.setAttribute('data-fh-ready', '');

      var main = pdp.querySelector('[data-fh-main]');
      var thumbs = pdp.querySelectorAll('[data-fh-thumb]');
      function showMedia(src, srcset, alt) {
        if (!main) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = src; if (srcset) main.srcset = srcset; main.alt = alt || '';
          main.style.opacity = '1';
        }, 160);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          showMedia(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt'));
        });
      });

      var form = pdp.querySelector('[data-fh-form]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('[data-fh-qty]');
      var submit = form.querySelector('[data-fh-submit]');
      var submitLabel = submit ? submit.querySelector('[data-fh-label]') : null;
      var msg = pdp.querySelector('[data-fh-msg]');
      var priceNow = pdp.querySelector('[data-fh-now]');
      var priceWas = pdp.querySelector('[data-fh-was]');
      var priceSave = pdp.querySelector('[data-fh-save]');
      var variantsEl = pdp.querySelector('[data-fh-variants]');
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var moneyFormat = pdp.getAttribute('data-fh-money') || '{{amount_with_comma_separator}} €';
      var txtAdd = pdp.getAttribute('data-fh-txt-add');
      var txtSold = pdp.getAttribute('data-fh-txt-sold');
      var txtUnavailable = pdp.getAttribute('data-fh-txt-unavailable');
      var txtAdded = pdp.getAttribute('data-fh-txt-added');

      function formatMoney(cents) {
        var value = (cents / 100).toFixed(2);
        var parts = value.split('.');
        var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDot + ',' + parts[1])
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDot)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withComma)
          .replace(/\{\{\s*amount\s*\}\}/, withComma + '.' + parts[1]);
      }

      pdp.querySelectorAll('[data-fh-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-fh-step'), 10));
          qtyInput.value = v;
        });
      });

      var optionSets = pdp.querySelectorAll('[data-fh-option]');
      function currentVariant() {
        var selected = [];
        optionSets.forEach(function (set) {
          var checked = set.querySelector('input:checked');
          selected.push(checked ? checked.value : null);
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
      }
      function updateVariant() {
        var v = currentVariant();
        if (!v) {
          if (submit) submit.disabled = true;
          if (submitLabel) submitLabel.textContent = txtUnavailable;
          return;
        }
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = formatMoney(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.hidden = !onSale; if (onSale) priceWas.textContent = formatMoney(v.compare_at_price); }
        if (priceSave) { priceSave.hidden = !onSale; if (onSale) priceSave.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
        if (submit) submit.disabled = !v.available;
        if (submitLabel) submitLabel.textContent = v.available ? txtAdd : txtSold;
        if (v.featured_media && v.featured_media.preview_image && main) {
          var thumb = pdp.querySelector('[data-fh-thumb][data-media-id="' + v.featured_media.id + '"]');
          if (thumb) thumb.click();
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      optionSets.forEach(function (set) { set.addEventListener('change', updateVariant); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submit.disabled) return;
        if (msg) msg.textContent = '';
        submit.classList.add('is-loading');
        addToCart(parseInt(idInput.value, 10), parseInt(qtyInput ? qtyInput.value : 1, 10) || 1).then(function () {
          submit.classList.remove('is-loading');
          if (submitLabel) { submitLabel.textContent = txtAdded; setTimeout(function () { submitLabel.textContent = txtAdd; }, 2200); }
        }).catch(function (err) {
          submit.classList.remove('is-loading');
          if (msg) msg.textContent = err.message;
        });
      });
    });
  }

  /* ---------- Newsletter: mensaje de confirmación ---------- */
  function initNewsletter() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    var msg = document.querySelector('[data-fh-news-ok]');
    if (msg) msg.hidden = false;
  }

  function initAll(root) {
    if (!document.documentElement.classList.contains('shopify-design-mode')) autoTag(root);
    initReveal(root);
    initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initHeroParallax();
    initOutlineDrift();
    initHeroVideo();
    initQuickAdd();
    initNewsletter();
  });

  /* Editor de Shopify: re-inicializar al cambiar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
